// Teams list
export const FETCH_TEAMS = 'FETCH_TEAMS';
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_FAIL = 'FETCH_TEAMS_FAIL';

// Single team (detail)
export const FETCH_TEAM = 'FETCH_TEAM';
export const FETCH_TEAM_SUCCESS = 'FETCH_TEAM_SUCCESS';
export const FETCH_TEAM_FAIL = 'FETCH_TEAM_FAIL';
export const CLEAR_SELECTED_TEAM = 'CLEAR_SELECTED_TEAM';

// Create
export const CREATE_TEAM = 'CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAIL = 'CREATE_TEAM_FAIL';

// Update
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const UPDATE_TEAM_SUCCESS = 'UPDATE_TEAM_SUCCESS';
export const UPDATE_TEAM_FAIL = 'UPDATE_TEAM_FAIL';

// Delete
export const DELETE_TEAM = 'DELETE_TEAM';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_FAIL = 'DELETE_TEAM_FAIL';

// Members
export const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
export const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS';
export const ADD_TEAM_MEMBER_FAIL = 'ADD_TEAM_MEMBER_FAIL';

export const REMOVE_TEAM_MEMBER = 'REMOVE_TEAM_MEMBER';
export const REMOVE_TEAM_MEMBER_SUCCESS = 'REMOVE_TEAM_MEMBER_SUCCESS';
export const REMOVE_TEAM_MEMBER_FAIL = 'REMOVE_TEAM_MEMBER_FAIL';

export const UPDATE_TEAM_MEMBER_ROLE = 'UPDATE_TEAM_MEMBER_ROLE';
export const UPDATE_TEAM_MEMBER_ROLE_SUCCESS = 'UPDATE_TEAM_MEMBER_ROLE_SUCCESS';
export const UPDATE_TEAM_MEMBER_ROLE_FAIL = 'UPDATE_TEAM_MEMBER_ROLE_FAIL';

// Responsibilities (Slice 2)
export const FETCH_TEAM_RESPONSIBILITIES = 'FETCH_TEAM_RESPONSIBILITIES';
export const FETCH_TEAM_RESPONSIBILITIES_SUCCESS = 'FETCH_TEAM_RESPONSIBILITIES_SUCCESS';
export const FETCH_TEAM_RESPONSIBILITIES_FAIL = 'FETCH_TEAM_RESPONSIBILITIES_FAIL';

export const ATTACH_TEAM_RESPONSIBILITY = 'ATTACH_TEAM_RESPONSIBILITY';
export const ATTACH_TEAM_RESPONSIBILITY_SUCCESS = 'ATTACH_TEAM_RESPONSIBILITY_SUCCESS';
export const ATTACH_TEAM_RESPONSIBILITY_FAIL = 'ATTACH_TEAM_RESPONSIBILITY_FAIL';

export const ATTACH_TEAM_RESPONSIBILITIES_BULK = 'ATTACH_TEAM_RESPONSIBILITIES_BULK';
export const ATTACH_TEAM_RESPONSIBILITIES_BULK_SUCCESS = 'ATTACH_TEAM_RESPONSIBILITIES_BULK_SUCCESS';
export const ATTACH_TEAM_RESPONSIBILITIES_BULK_FAIL = 'ATTACH_TEAM_RESPONSIBILITIES_BULK_FAIL';

export const DETACH_TEAM_RESPONSIBILITY = 'DETACH_TEAM_RESPONSIBILITY';
export const DETACH_TEAM_RESPONSIBILITY_SUCCESS = 'DETACH_TEAM_RESPONSIBILITY_SUCCESS';
export const DETACH_TEAM_RESPONSIBILITY_FAIL = 'DETACH_TEAM_RESPONSIBILITY_FAIL';

// Clear feedback messages
export const CLEAR_TEAM_MESSAGES = 'CLEAR_TEAM_MESSAGES';
